export default __webpack_public_path__ + "static/media/seashell7.9e596097.svg";